<template>
  <div class="w-100" style="position: absolute; z-index: 999; height: 4px">
    <v-fade-transition>
      <v-progress-linear
        v-show="shouldRenderLoadingBar"
        class="mx-0"
        :color="progressBarColor"
        height="4"
        indeterminate
      />
    </v-fade-transition>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '#5278bb',
  },
});

const store = useStore();
const saveInFlight = computed(() => store.getters['editObject/saveInFlight']);
const searchInFlight = computed(() => store.getters['editObject/searchInFlight']);

const shouldRenderLoadingBar = computed(() => {
  if (props.show) return true;
  return saveInFlight.value || searchInFlight.value;
});

/**
 * Determines progress bar color.
 */
const progressBarColor = computed(() => {
  const raBlue = '#5278bb';
  if (props.show) return raBlue; // Exit early with RA blue if manually toggling.

  // Cascade by level of importance
  if (saveInFlight.value) return 'green';
  if (searchInFlight.value) return raBlue;
  return 'transparent';
});
</script>
